var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWiningCampainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2L17.8499 9L6.1499 9L11.9999 2Z",
    fill: "#33850D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5L14 7.5L14 21H10L10 7.5Z",
    fill: "#33850D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiningCampainIcon);
export default __webpack_public_path__ + "static/media/winingCampainIcon.a47062b372831f488274f3fdfb1093d2.svg";
export { ForwardRef as ReactComponent };